













import { computed, defineComponent, ref } from '@vue/composition-api'
import { useApi } from '@/composable/useApi'
import { useToasts } from '@/composable/useToasts'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'SelectableResourceTypes',

  props: {
    value: {
      type: Object as PropType<{ resource_types?: string[] }>,
      required: true
    }
  },

  setup(props, { emit }) {
    const { addErrorToast } = useToasts()

    const loading = ref(true)
    const items = ref<string[]>([])

    const resourceTypes = computed({
      get: () => props.value.resource_types,
      set: (resource_types) => emit('input', { ...props.value, resource_types })
    })

    useApi()
      .settings.dynamicResources({ compact: true })
      .then((val) => (items.value = val.filter((item) => item.startsWith('catalog'))))
      .catch((err) => addErrorToast(err.response?.data.message))
      .finally(() => (loading.value = false))

    return {
      resourceTypes,
      items,
      loading
    }
  }
})
